import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Star, Clock, Calendar, ArrowRight } from "lucide-react";
import { Button } from "../../../design-system/index.js";
import { cn } from "../../../design-system/index.js";

const BENEFICIOS = [
  { icon: ShieldCheck, title: "Babás verificadas", desc: "Todas passam por checagem de antecedentes e entrevista presencial." },
  { icon: Star, title: "Avaliações reais", desc: "Veja opiniões de outras famílias antes de contratar." },
  { icon: Clock, title: "Agendamento flexível", desc: "Escolha o horário que melhor se encaixa na sua rotina." },
  { icon: Calendar, title: "Contrato garantido", desc: "Toda contratação é formalizada com contrato digital." },
];

export default function FamiliesPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-warm-50 pt-32 pb-16">
      <div className="mx-auto max-w-4xl px-4 sm:px-6">

        {/* Hero */}
        <div className="text-center mb-14">
          <span className="inline-block rounded-full bg-rose-400/12 px-3 py-1 text-xs font-semibold text-rose-400 mb-4">
            Para famílias
          </span>
          <h1 className={cn(
            "font-heading text-4xl sm:text-5xl font-bold",
            "text-warm-900 mb-4"
          )}>
            Encontre a babá ideal{" "}
            <span className="text-rose-400">com segurança</span>
          </h1>
          <p className="text-lg text-warm-600 max-w-xl mx-auto leading-relaxed">
            Profissionais verificadas, avaliações reais e suporte da plataforma.
          </p>
        </div>

        {/* Benefícios */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-14">
          {BENEFICIOS.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="flex gap-4 bg-white rounded-2xl p-5 shadow-sm border border-warm-100">
              <div className="shrink-0 flex h-10 w-10 items-center justify-center rounded-xl bg-rose-400/12">
                <Icon size={20} className="text-rose-400" />
              </div>
              <div>
                <h3 className="font-semibold text-warm-900 mb-1">{title}</h3>
                <p className="text-sm text-warm-500 leading-relaxed">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="bg-gradient-to-br from-rose-400 to-[#d4736a] rounded-3xl p-8 text-center text-white">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold mb-3">Pronta para começar?</h2>
          <p className="text-white/80 mb-6 max-w-sm mx-auto">Cadastro gratuito. Encontre a babá perfeita em minutos.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              variant="secondary"
              size="lg"
              className="rounded-full bg-white px-7 py-3 font-bold text-rose-400 shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all"
              onClick={() => navigate("/cadastro-familia")}
            >
              Criar conta grátis <ArrowRight size={16} />
            </Button>
            <Button
              variant="ghost"
              size="lg"
              className="rounded-full border-2 border-white/60 px-7 py-3 font-bold text-white hover:bg-white/10"
              onClick={() => navigate("/login")}
            >
              Já tenho conta
            </Button>
          </div>
        </div>

      </div>
    </div>
  );
}
